import { render, staticRenderFns } from "./dialogReviewPlatformAdd.vue?vue&type=template&id=249d2dc8&"
import script from "./dialogReviewPlatformAdd.vue?vue&type=script&lang=js&"
export * from "./dialogReviewPlatformAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
